exports.XMLHttpRequest = XMLHttpRequest;